import React from 'react';
import styles from './TableCard.module.scss';

type ProgressBarProps = {
  step: number;
};

export const ProgressBar = ({ step }: ProgressBarProps) => {
  const filledStyles = {
    width: `${(100 / 3) * step}%`,
  };
  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressFilled} style={filledStyles}>
        <span className={styles.progressLabel}>{`${step} шаг`}</span>
      </div>
    </div>
  );
};
